import { render, staticRenderFns } from "./DatasetCustomField.vue?vue&type=template&id=664f0a98&scoped=true"
import script from "./DatasetCustomField.vue?vue&type=script&lang=js"
export * from "./DatasetCustomField.vue?vue&type=script&lang=js"
import style0 from "./DatasetCustomField.vue?vue&type=style&index=0&id=664f0a98&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "664f0a98",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\ideaWorkSpace\\zcy-dataEase\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('664f0a98')) {
      api.createRecord('664f0a98', component.options)
    } else {
      api.reload('664f0a98', component.options)
    }
    module.hot.accept("./DatasetCustomField.vue?vue&type=template&id=664f0a98&scoped=true", function () {
      api.rerender('664f0a98', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/dataset/common/DatasetCustomField.vue"
export default component.exports